import React from 'react';
import { useClearCache } from 'react-clear-cache';

import css from './version.module.css';

export default () => {
  const {loading} = useClearCache({
    auto: true
  });

  return (
    <div className={css.Container}>
      {loading && <p className={css.Checking}>checking for new version...</p>}
    </div>
  )
}